import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

@vsingleton()
export class PanelBillingInfoRoute extends RouteBase {
  prefix = 'panel.financial.billing_info.'

  billingInfoUpdate() {
    return this.ziggyRoute('update')
  }

  billingInfoIndex() {
    return this.ziggyRoute('index')
  }

  billingShow() {
    return this.ziggyRoute('show')
  }

}
